import React from 'react'
import { Box, Text } from '@workwhile/ui'
import { formatCurrency } from 'lib/currency'
import { CopyableLink } from 'components/Shared/CopyableLink'
import { usePayHealthStipendFlowContextValue } from '../context/PayHealthStipendFlowProvider'

type HealthStipendResultData = NonNullable<
  ReturnType<
    typeof usePayHealthStipendFlowContextValue
  >['state']['mutationState']['data']
>

const OUTCOME_LABELS: Record<HealthStipendResultData['outcome'], string> = {
  paid: 'Paid',
  already_paid: 'Already paid for this quarter',
  below_minimum_hours: 'Not paid: below minimum hours',
  no_driving_hours: 'Not paid: no driving hours',
}

const ResultRow = ({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) => (
  <Text mt={2}>
    <Text as="span" fontWeight="bold">
      {label}:
    </Text>{' '}
    {children}
  </Text>
)

export const HealthStipendResult = ({
  workerId,
  result,
}: {
  workerId: number
  result: HealthStipendResultData
}) => (
  <Box>
    <ResultRow label="Worker">
      <CopyableLink label={workerId} link={`/users/${workerId}`} />
    </ResultRow>
    <ResultRow label="Outcome">
      {OUTCOME_LABELS[result.outcome] ?? result.outcome}
    </ResultRow>
    <ResultRow label="Avg engaged hours / week">
      {result.avgEngagedHoursPerWeek == null
        ? '—'
        : result.avgEngagedHoursPerWeek.toFixed(2)}
    </ResultRow>
    <ResultRow label="Amount">
      {formatCurrency(Number(result.amount))}
    </ResultRow>
    <ResultRow label="Payment ID">
      {result.userPaymentId == null ? (
        '—'
      ) : (
        <CopyableLink
          label={result.userPaymentId}
          link={`/user_payments?payment-id=${result.userPaymentId}`}
        />
      )}
    </ResultRow>
  </Box>
)
